import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import {iconsSet as icons} from './assets/icons/icons.js'
import store from './store'
import '@babel/polyfill'

import dotenv from 'dotenv'

dotenv.config()

import {COMMON} from '@/common/Constant'

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBjW0WBNQT8mQOLHAafXi-wvY4OZJASyvg',
    libraries: 'places',
    v: 3.38
  },
  installComponents: true
})

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Quill from 'quill'
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'

Quill.register('modules/emoji', quillEmoji)

import QuillResize, {PlaceholderRegister} from 'quill-resize-module'

Quill.register('modules/resize', QuillResize)
PlaceholderRegister()
import {ImageDrop} from 'quill-image-drop-module'

Quill.register('modules/imageDrop', ImageDrop)

Vue.use(VueQuillEditor, COMMON.quillEditorOption)

import _ from 'lodash'

Vue.use(_)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
Vue.use(VueNotifications, options)

import {ValidationObserver, ValidationProvider, extend, localize} from 'vee-validate'
import vi from 'vee-validate/dist/locale/vi.json'
import * as rules from 'vee-validate/dist/rules'

localize('vi', vi)

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import VueEasytable from 'vue-easytable'
import 'vue-easytable/libs/theme-default/index.css'

Vue.use(VueEasytable)

import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin)

import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/ayu-dark.css'
import 'codemirror/mode/sass/sass'

Vue.use(VueCodemirror)

Vue.prototype.$log = console.log.bind(console)

import * as firebase from "firebase";
require('firebase/auth');
require('firebase/database');
require('firebase/storage');

const firebaseConfig = {
  apiKey: "AIzaSyBHj-3TFWE_MNaLuI_F57IXnJBTPV4YMaQ",
  authDomain: "dakland-a33e0.firebaseapp.com",
  projectId: "dakland-a33e0",
  storageBucket: "dakland-a33e0.appspot.com",
  messagingSenderId: "97996052154",
  appId: "1:97996052154:web:05888834eb4a845cd81483",
  measurementId: "G-4PRXYLEFX7"
};

firebase.initializeApp(firebaseConfig)

export const storage = firebase.storage();

// Dummy login
firebase
  .auth()
  .signInWithEmailAndPassword("admin@root.com", "!admin@daklandauth#2021")
  // eslint-disable-next-line no-unused-vars
  .then(data => {
    // console.log('firebase auth success', data)
  })
  // eslint-disable-next-line no-unused-vars
  .catch(err => {
    // console.log('firebase auth error', err)
  });

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
